import { compose } from "redux";
import { IResponseState } from "../../../components/Modals/ResponseModal/module/constants";
import { IAction } from "../../../models/Action";
import { immutableSet } from "../../../utils/immutable";
import { actionTypes } from "./actions";
import {
  LIST_IDENTIFIER,
  LOADER_IDENTIFIER,
  STATE_IDENTIFIER,
} from "./constants";
import emptyState from "./emptyState";
import { IDENTITY_SYSTEM } from "../../../module/constants";

const {
  TEMPORARY_ABILITATIONS,
  SELECTED_TEMPORARY_ABILITATION,
  FIELDS,
  REQUEST_STATE,
  EMERGENCY_TEMPORARY_ABILITATIONS,
  SHOW_EMERGENCY,
  SHOW_EMERGENCY_LOADER,
  MISSING_ENTITLEMENTS,
} = STATE_IDENTIFIER;

const ACTION_HANDLERS = {
  [actionTypes.TEMPORARY_ABILITATIONS_FETCH_REQUEST]: (
    state: any,
    action: any
  ) => immutableSet([TEMPORARY_ABILITATIONS, LOADER_IDENTIFIER], true, state),

  [actionTypes.TEMPORARY_ABILITATIONS_FETCH_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => {
    let { userEntitlements, responseCode, responseStatus, ...paginationData } =
      action.payload;
    const fineResponse: any[] = [];

    userEntitlements &&
      userEntitlements.length > 0 &&
      userEntitlements.forEach((entitlement: any) => {
        const tempEntitlement = {
          ...entitlement,
          identitySystemId:
            IDENTITY_SYSTEM[
              entitlement.identitySystemId as keyof typeof IDENTITY_SYSTEM
            ],
          uniqueId: entitlement.id,
        };
        delete tempEntitlement.emergencyName;
        delete tempEntitlement.id;

        fineResponse.push(tempEntitlement);
      });

    const mappedResponse = {
      ...paginationData,
      responseCode,
      responseStatus,
      userEntitlements: fineResponse,
    };
    return compose(
      immutableSet([TEMPORARY_ABILITATIONS, LIST_IDENTIFIER], mappedResponse),
      immutableSet([TEMPORARY_ABILITATIONS, LOADER_IDENTIFIER], false)
    )(state);
  },

  [actionTypes.TEMPORARY_ABILITATIONS_FETCH_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) => immutableSet([TEMPORARY_ABILITATIONS, LOADER_IDENTIFIER], false, state),

  [actionTypes.SET_SELECTED_TEMPORARY_ABILITATION]: (state: any, action: any) =>
    immutableSet(
      [TEMPORARY_ABILITATIONS, SELECTED_TEMPORARY_ABILITATION],
      action.payload,
      state
    ),

  [actionTypes.SEND_TEMPORARY_ABILITATION_REQUEST_ACTION]: (
    state: any,
    action: any
  ) => immutableSet([REQUEST_STATE], IResponseState.PENDING, state),

  [actionTypes.SEND_TEMPORARY_ABILITATION_REQUEST_ACTION_SUCCESS]: (
    state: any,
    action: any
  ) => immutableSet([REQUEST_STATE], IResponseState.SUCCESS, state),

  [actionTypes.SEND_TEMPORARY_ABILITATION_REQUEST_ACTION_FAILURE]: (
    state: any,
    action: any
  ) => immutableSet([REQUEST_STATE], IResponseState.ERROR, state),

  [actionTypes.GET_FIELDS_SELECTED_TEMPORARY_ABILITATION_REQUEST_ACTION]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [TEMPORARY_ABILITATIONS, FIELDS, LOADER_IDENTIFIER],
      true,
      state
    ),

  [actionTypes.GET_FIELDS_SELECTED_TEMPORARY_ABILITATION_REQUEST_ACTION_SUCCESS]:
    (state: any, action: any) => {
      let mappedResponse = [] as any[];
      if (
        action.payload &&
        action.payload.fields &&
        action.payload.fields.length > 0
      ) {
        action.payload.fields.forEach((field: string) =>
          mappedResponse.push({ uniqueId: field, field: field, fieldValue: "" })
        );
      }
      return compose(
        immutableSet(
          [TEMPORARY_ABILITATIONS, FIELDS, LIST_IDENTIFIER],
          mappedResponse
        ),
        immutableSet([TEMPORARY_ABILITATIONS, FIELDS, LOADER_IDENTIFIER], false)
      )(state);
    },

  [actionTypes.GET_FIELDS_SELECTED_TEMPORARY_ABILITATION_REQUEST_ACTION_FAILURE]:
    (state: any, action: any) =>
      immutableSet(
        [TEMPORARY_ABILITATIONS, FIELDS, LOADER_IDENTIFIER],
        false,
        state
      ),

  [actionTypes.GET_FIELDS_SELECTED_TEMPORARY_EMERGENCY_ABILITATION_REQUEST_ACTION]:
    (state: any, action: any) =>
      immutableSet(
        [EMERGENCY_TEMPORARY_ABILITATIONS, FIELDS, LOADER_IDENTIFIER],
        true,
        state
      ),

  [actionTypes.GET_FIELDS_SELECTED_TEMPORARY_EMERGENCY_ABILITATION_REQUEST_ACTION_SUCCESS]:
    (state: any, action: any) => {
      let mappedResponse = [] as any[];
      if (
        action.payload &&
        action.payload.fields &&
        action.payload.fields.length > 0
      ) {
        action.payload.fields.forEach((field: string) =>
          mappedResponse.push({ uniqueId: field, field: field, fieldValue: "" })
        );
      }
      return compose(
        immutableSet(
          [EMERGENCY_TEMPORARY_ABILITATIONS, FIELDS, LIST_IDENTIFIER],
          mappedResponse
        ),
        immutableSet(
          [EMERGENCY_TEMPORARY_ABILITATIONS, FIELDS, LOADER_IDENTIFIER],
          false
        )
      )(state);
    },

  [actionTypes.GET_FIELDS_SELECTED_TEMPORARY_EMERGENCY_ABILITATION_REQUEST_ACTION_FAILURE]:
    (state: any, action: any) =>
      immutableSet(
        [EMERGENCY_TEMPORARY_ABILITATIONS, FIELDS, LOADER_IDENTIFIER],
        false,
        state
      ),

  [actionTypes.CHECK_REQUIREMENT_ENTITLEMENTS]: (state: any, action: any) =>
    immutableSet([MISSING_ENTITLEMENTS], [], state),

  [actionTypes.CHECK_REQUIREMENT_ENTITLEMENTS_SUCCESS]: (
    state: any,
    action: any
  ) => {
    return immutableSet([MISSING_ENTITLEMENTS], action.payload, state);
  },

  [actionTypes.CHECK_REQUIREMENT_ENTITLEMENTS_FAILURE]: (
    state: any,
    action: any
  ) => {
    return immutableSet([MISSING_ENTITLEMENTS], [], state);
  },

  [actionTypes.GET_EMERGENCY_CHECK_REQUEST]: (state: any, action: any) =>
    immutableSet([SHOW_EMERGENCY_LOADER], true, state),

  [actionTypes.GET_EMERGENCY_CHECK_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => {
    return compose(
      immutableSet([SHOW_EMERGENCY], action.payload),
      immutableSet([SHOW_EMERGENCY_LOADER], false)
    )(state);
  },

  [actionTypes.GET_EMERGENCY_CHECK_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) => {
    return compose(
      immutableSet([SHOW_EMERGENCY], false),
      immutableSet([SHOW_EMERGENCY_LOADER], false)
    )(state);
  },

  [actionTypes.GET_EMERGENCY_TEMPORARY_ABILITATIONS_FETCH_REQUEST]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [EMERGENCY_TEMPORARY_ABILITATIONS, LOADER_IDENTIFIER],
      true,
      state
    ),

  [actionTypes.GET_EMERGENCY_TEMPORARY_ABILITATIONS_FETCH_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => {
    let { userEntitlements, responseCode, responseStatus, ...paginationData } =
      action.payload;
    const fineResponse: any[] = [];

    userEntitlements &&
      userEntitlements.length > 0 &&
      userEntitlements.forEach((entitlement: any) => {
        const tempEntitlement = {
          ...entitlement,
          uniqueId: entitlement.id,
          identitySystemId:
            IDENTITY_SYSTEM[
              entitlement.identitySystemId as keyof typeof IDENTITY_SYSTEM
            ],
        };
        delete tempEntitlement.id;
        fineResponse.push(tempEntitlement);
      });

    const mappedResponse = {
      ...paginationData,
      responseCode,
      responseStatus,
      userEntitlements: fineResponse,
    };
    return compose(
      immutableSet(
        [EMERGENCY_TEMPORARY_ABILITATIONS, LIST_IDENTIFIER],
        mappedResponse
      ),
      immutableSet([EMERGENCY_TEMPORARY_ABILITATIONS, LOADER_IDENTIFIER], false)
    )(state);
  },

  [actionTypes.GET_EMERGENCY_TEMPORARY_ABILITATIONS_FETCH_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) => {
    return compose(
      immutableSet([EMERGENCY_TEMPORARY_ABILITATIONS, LIST_IDENTIFIER], []),
      immutableSet([EMERGENCY_TEMPORARY_ABILITATIONS, LOADER_IDENTIFIER], false)
    )(state);
  },

  [actionTypes.SET_SELECTED_EMERGENCY_TEMPORARY_ABILITATION]: (
    state: any,
    action: any
  ) => {
    return immutableSet(
      [EMERGENCY_TEMPORARY_ABILITATIONS, SELECTED_TEMPORARY_ABILITATION],
      action.payload,
      state
    );
  },

  [actionTypes.SET_FIELD_VALUE_SELECTED_TEMPORARY_ABILITATION]: (
    state: any,
    action: any
  ) => {
    let mappedResponse = [] as any[];
    let fieldsArray = [...state.temporaryAbilitations.fields.list];
    fieldsArray.forEach((field: any) => {
      if (field.field === action.payload.field) {
        let obj = {
          ...field,
          fieldValue: action.payload.fieldValue,
        };
        mappedResponse.push(obj);
      } else {
        mappedResponse.push(field);
      }
    });
    return immutableSet(
      [TEMPORARY_ABILITATIONS, FIELDS, LIST_IDENTIFIER],
      mappedResponse,
      state
    );
  },

  [actionTypes.SET_FIELD_VALUE_SELECTED_TEMPORARY_EMERGENCY_ABILITATION]: (
    state: any,
    action: any
  ) => {
    let mappedResponse = [] as any[];
    let fieldsArray = [...state.temporaryAbilitations.fields.list];
    fieldsArray.forEach((field: any) => {
      if (field.field === action.payload.field) {
        let obj = {
          ...field,
          fieldValue: action.payload.fieldValue,
        };
        mappedResponse.push(obj);
      } else {
        mappedResponse.push(field);
      }
    });
    return immutableSet(
      [EMERGENCY_TEMPORARY_ABILITATIONS, FIELDS, LIST_IDENTIFIER],
      mappedResponse,
      state
    );
  },

  [actionTypes.RESET_STATE_TEMPORARY_ABILITATIONS]: (state: any, action: any) =>
    emptyState,
};

export default function communicationReducer(
  state = emptyState,
  action: IAction
) {
  if (
    action &&
    action.type === "@@router/LOCATION_CHANGE" &&
    (action.payload.location.pathname === "/welcome" ||
      action.payload.location.pathname === "/admin")
  ) {
    return emptyState;
  }
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
